<script lang="ts">
  import Flash, { type FlashState } from '#app/lib/components/flash.svelte'
  import { screen } from '#app/lib/components/stores/screen'
  import { icon } from '#app/lib/icons'
  import type { Align } from '#components/dropdown.svelte'
  import AddToDotDotDotMenu from '#entities/components/layouts/add_to_dot_dot_dot_menu.svelte'
  import type { SerializedEntity } from '#entities/lib/entities'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import { i18n } from '#user/lib/i18n'

  let {
    entity,
    editions = null,
    someEditions = false,
    allItems = $bindable([]),
    align = null,
    scrollToItemsList,
    showMapAndScrollToMap,
  }: {
    entity: SerializedEntity
    editions?: SerializedEntity[]
    someEditions?: boolean
    allItems?: SerializedItemWithUserData[]
    align?: Align
    scrollToItemsList?: () => void
    showMapAndScrollToMap?: () => void
  } = $props()

  let flash: FlashState

  const otherUsersItems = $derived(allItems?.filter(item => !item.mainUserIsOwner))
  const areNotOnlyMainUserItems = $derived(otherUsersItems?.length > 0)
  const someOtherUsersItemsHaveAPosition = $derived(otherUsersItems?.find(item => item.distanceFromMainUser != null))
</script>

<div class="actions-wrapper">
  <AddToDotDotDotMenu
    {entity}
    {editions}
    {flash}
    {align}
  />
  {#if someEditions && areNotOnlyMainUserItems}
    {#if $screen.isSmallerThan('$small-screen')}
      <button
        onclick={scrollToItemsList}
        title={i18n('Show users who have these editions')}
        class="action-button"
      >
        {@html icon('user')}
        {i18n('Show who has this book')}
        {#if otherUsersItems}({otherUsersItems.length}){/if}
      </button>
    {/if}
    {#if someOtherUsersItemsHaveAPosition}
      <button
        onclick={showMapAndScrollToMap}
        title={i18n('Show users who have these editions on a map')}
        class="action-button"
      >
        {@html icon('map-marker')}
        {i18n('Show books on a map')}
      </button>
    {/if}
  {/if}
</div>
<Flash state={flash} />

<style lang="scss">
  @import "general/scss/utils";
  .actions-wrapper{
    @include display-flex(column, stretch, center);
    margin: 1em 0;
    min-inline-size: 10em;
    .action-button, :global(.add-to-dot-dot-dot-menu){
      margin-block-end: 0.3em;
    }
    .action-button, :global(.add-to-dot-dot-dot-menu-button){
      text-align: end;
    }
    .action-button, :global(.dropdown-button){
      text-align: start;
    }
  }
  .action-button{
    @include tiny-button($light-grey, black);
  }
  /* Smaller screens */
  @media screen and (width < $smaller-screen){
    .actions-wrapper{
      @include display-flex(row);
    }
  }
</style>
